import { render, staticRenderFns } from "./TerrenoJuegoComponent.vue?vue&type=template&id=6008ef1a&scoped=true"
import script from "./TerrenoJuegoComponent.vue?vue&type=script&lang=js"
export * from "./TerrenoJuegoComponent.vue?vue&type=script&lang=js"
import style0 from "./TerrenoJuegoComponent.vue?vue&type=style&index=0&id=6008ef1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6008ef1a",
  null
  
)

export default component.exports